var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.6668 1.89063V5.33274C11.6668 5.79945 11.6668 6.03281 11.7577 6.21107C11.8376 6.36787 11.965 6.49535 12.1218 6.57525C12.3001 6.66608 12.5335 6.66608 13.0002 6.66608H16.4423M11.6668 14.166H6.66683M13.3335 10.8327H6.66683M16.6668 8.32287V14.3327C16.6668 15.7328 16.6668 16.4329 16.3943 16.9677C16.1547 17.4381 15.7722 17.8205 15.3018 18.0602C14.767 18.3327 14.067 18.3327 12.6668 18.3327H7.3335C5.93336 18.3327 5.2333 18.3327 4.69852 18.0602C4.22811 17.8205 3.84566 17.4381 3.60598 16.9677C3.3335 16.4329 3.3335 15.7328 3.3335 14.3327V5.66602C3.3335 4.26588 3.3335 3.56582 3.60598 3.03104C3.84566 2.56063 4.22811 2.17818 4.69852 1.9385C5.2333 1.66602 5.93336 1.66602 7.3335 1.66602H10.01C10.6215 1.66602 10.9272 1.66602 11.2149 1.73509C11.47 1.79633 11.7139 1.89734 11.9375 2.03442C12.1898 2.18902 12.406 2.40521 12.8384 2.83759L15.4953 5.49444C15.9276 5.92682 16.1438 6.14301 16.2984 6.3953C16.4355 6.61898 16.5365 6.86285 16.5978 7.11794C16.6668 7.40566 16.6668 7.71139 16.6668 8.32287Z",
    stroke: "#424242",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile05);
export default __webpack_public_path__ + "static/media/file-05.e7a49c5bfc30266b1a36eded35a1c18d.svg";
export { ForwardRef as ReactComponent };